module.exports = __webpack_public_path__ + "img/texture_5.4e7fb051.png";